<template>
  <div>
    <br>
    <br>
    <div class="section py-0 px-5">
      <vue-slider :min="isochroneMin"
                  :max="isochroneMax"
                  :interval="isochroneInterval"
                  :clickable=false
                  v-model="isochroneLocal"
                  ref="slider"
                  tooltip="always"
                  formatter="{value} min"
                  @drag-end="dragEnd"/>
    </div>
    <hr>
    <section>
      <div class="field">
        <b-radio v-model="typeLayerGeoMarketingLocal"
            :native-value="typeLayerEmpty"
            class="correctionMargeManquante miseEnFormeRadio"
            :class="{ selected: typeLayerGeoMarketingLocal === typeLayerEmpty }">
          <b-icon icon="map-legend" type="is-primary"></b-icon>
          <span class="size14">Carte uniquement</span>
        </b-radio>
        <b-radio v-model="typeLayerGeoMarketingLocal"
            :native-value="typeLayerGeoMarketingDemo"
            class="miseEnFormeRadio"
            :class="{ selected: typeLayerGeoMarketingLocal === typeLayerGeoMarketingDemo }">
          <b-icon icon="account-multiple" type="is-primary"></b-icon>
          <span class="size14">Données socio-démographiques</span><br /><br />
          <div class="columns">
            <div class="column is-6 has-text-centered">
              <span class="size24" v-if="geoData">{{ geoData.items[0][0].text }}</span><br />
              <span class="size12">Ménages</span>
            </div>
            <div class="column is-6 has-text-centered">
              <span class="size24" v-if="geoData">{{ geoData.items[1][0].text }}</span><br />
              <span class="size12">Population</span>
            </div>
          </div>
        </b-radio>
        <b-radio v-model="typeLayerGeoMarketingLocal"
            :native-value="typeLayerGeoMarketingEco"
            class="miseEnFormeRadio"
            :class="{ selected: typeLayerGeoMarketingLocal === typeLayerGeoMarketingEco }">
          <b-icon icon="cash-multiple" type="is-primary"></b-icon>
          <span class="size14">Données socio-économiques</span><br /><br />
          <div class="columns">
            <div class="column is-12 has-text-centered">
              <span class="size24" v-if="geoData">{{ geoData.items[2][0].text }}</span><br />
              <span class="size12">/ ménage</span>
            </div>
          </div>
        </b-radio>
        <b-radio v-model="typeLayerGeoMarketingLocal"
            :native-value="typeLayerGeoMarketingConcu"
            :disabled="isConcurrenceDisabled"
            class="miseEnFormeRadio"
            :class="{ selected: typeLayerGeoMarketingLocal === typeLayerGeoMarketingConcu }">
          <b-icon icon="domain" type="is-primary"></b-icon>
          <span class="size14">Concurrence</span>
        </b-radio>
      </div>
    </section>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import { ISOCHRONE_MAX, ISOCHRONE_MIN, ISOCHRONE_INTERVAL,
  TYPE_LAYER_EMPTY, TYPE_LAYER_GEO_MARKETING_DEMO,
  TYPE_LAYER_GEO_MARKETING_ECO, TYPE_LAYER_GEO_MARKETING_CONCU } from '@/configuration/carteConf';
import { getBasicData } from '@/api/asterop';

export default {
  name: 'filtresGeoMarketting',
  props: ['address', 'isochrone', 'typeLayerGeoMarketing', 'update'],
  components: {
    vueSlider,
  },
  data() {
    return {
      isochroneMax: ISOCHRONE_MAX,
      isochroneMin: ISOCHRONE_MIN,
      isochroneInterval: ISOCHRONE_INTERVAL,
      typeLayerEmpty: TYPE_LAYER_EMPTY,
      typeLayerGeoMarketingDemo: TYPE_LAYER_GEO_MARKETING_DEMO,
      typeLayerGeoMarketingEco: TYPE_LAYER_GEO_MARKETING_ECO,
      typeLayerGeoMarketingConcu: TYPE_LAYER_GEO_MARKETING_CONCU,
      isolocal: false,
      typeLocal: false,
      geoData: false,
    };
  },
  async mounted() {
    await this.updateBasicData();
    setTimeout(() => {
      // TODO : Honteux
      this.$nextTick(() => this.$refs.slider.refresh());
    }, 300);
  },
  computed: {
    isochroneLocal: {
      get() {
        return this.isochrone;
      },
      set(value) {
        this.isolocal = value;
      },
    },
    typeLayerGeoMarketingLocal: {
      get() {
        return this.typeLayerGeoMarketing;
      },
      set(value) {
        this.typeLocal = value;
        this.updateProps();
      },
    },
    isConcurrenceDisabled() {
      if (this.address) return !Object.prototype.hasOwnProperty.call(this.address, 'codeType');
      return '';
    },
  },
  methods: {
    dragEnd() {
      this.updateProps();
    },
    updateProps() {
      if (!this.typeLocal) {
        this.typeLocal = this.typeLayerGeoMarketingLocal;
      }
      this.$emit('update', {
        isochrone: this.isolocal,
        typeLayerGeoMarketing: this.typeLocal,
      });
    },
    async updateBasicData() {
      this.geoData = null;
      if (this.address) {
        if (this.typeLayerGeoMarketingLocal === this.typeLayerGeoMarketingConcu &&
          this.isConcurrenceDisabled) {
          this.typeLayerGeoMarketingLocal = this.typeLayerEmpty;
        }
        const response = await getBasicData(this.address, this.isochrone);
        this.geoData = response.data;
      }
    },
  },
  watch: {
    isochrone() {
      this.updateBasicData();
    },
    address() {
      this.updateBasicData();
    },
  },
};
</script>

<style scoped>
.miseEnFormeRadio {
  padding-top: 19px;
  padding-bottom: 19px;
}

.correctionMargeManquante {
  margin-left: 0.5em;
}

.selected {
  width: 100%;
  background-color: #F2F7F9;
}

.size24 {
  font-size: 24px;
  font-weight: bold;
}

.size14 {
  font-size: 14px;
}

.size12 {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/filtresGeoMarketting.vue